import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import type { ChangelogEntryFilters, ChangelogCategory } from "@/types/changelog";

interface ChangelogFiltersProps {
  filters: ChangelogEntryFilters;
  categories: ChangelogCategory[];
  onFiltersChange: (filters: ChangelogEntryFilters) => void;
}

export function ChangelogFilters({
  filters,
  categories,
  onFiltersChange,
}: ChangelogFiltersProps) {
  const hasActiveFilters = Boolean(filters.status || filters.categoryId);

  const clearFilters = () => {
    onFiltersChange({ status: undefined, categoryId: undefined });
  };

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center">
      <Select
        value={filters.status || "ALL"}
        onValueChange={(value) =>
          onFiltersChange({
            ...filters,
            status: value === "ALL" ? undefined : (value as "draft" | "published"),
          })
        }
      >
        <SelectTrigger className="w-full md:w-[140px]" aria-label="상태 필터">
          <SelectValue placeholder="상태 선택" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="ALL">전체 상태</SelectItem>
          <SelectItem value="draft">임시저장</SelectItem>
          <SelectItem value="published">발행됨</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.categoryId || "ALL"}
        onValueChange={(value) =>
          onFiltersChange({
            ...filters,
            categoryId: value === "ALL" ? undefined : value,
          })
        }
      >
        <SelectTrigger className="w-full md:w-[160px]" aria-label="카테고리 필터">
          <SelectValue placeholder="카테고리 선택" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="ALL">전체 카테고리</SelectItem>
          {categories.map((cat) => (
            <SelectItem key={cat._id} value={cat._id}>
              {cat.name.ko}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {hasActiveFilters && (
        <Button
          variant="ghost"
          onClick={clearFilters}
          aria-label="필터 초기화"
        >
          <X className="mr-2 h-4 w-4" />
          초기화
        </Button>
      )}
    </div>
  );
}
